import { z } from "zod";
import { ClientSchema } from "./client";

const dateTransform = z.preprocess(
  (val) => (val ? new Date(val as string) : null),
  z.date().nullable()
);

export const JobSchema = z.object({
  jid: z.number(),
  jcontid: z.number().nullable(),
  jcid: z.number().nullable(),
  jlid: z.number().nullable(),
  jbid: z.number().nullable(),
  juid: z.number().nullable(),
  jouid: z.number().nullable(),
  jauid: z.number().nullable(),
  jpmgr: z.number().nullable(),
  jadate: dateTransform,
  jstatus: z.string().nullable(),
  qstatus: z.string().nullable(),
  jsched: dateTransform,
  jtype: z.string().nullable(),
  jsector: z.string().nullable(),
  jwork: z.string().nullable(),
  jprefdate: dateTransform,
  jodeldts: dateTransform,
  jodumpsterco: z.string().nullable(),
  jodumpsterdate: dateTransform,
  jopermit: dateTransform,
  joinspection: dateTransform,
  jinstaller: z.number().nullable(),
  jinstallon: dateTransform,
  jinstalldate: dateTransform,
  jinstalldesc: z.string().nullable(),
  jinsurance: z.string().nullable(),
  jinsuranceco: z.string().nullable(),
  jinsuranceadj: z.string().nullable(),
  jinsuranceadjphone: z.string().nullable(),
  jinsuranceadjemail: z.string().nullable(),
  jpublicadj: z.number().nullable(),
  jorigcoverage: z.string().nullable(),
  jclaimnum: z.string().nullable(),
  jwarranty: z.string().nullable(),
  jservice: z.string().nullable(),
  jnotes: z.string().nullable(),
  jreason: z.string().nullable(),
  jreasonuid: z.number().nullable(),
  jreasondts: dateTransform,
  jlink: z.number().nullable(),
  jcopiedfrom: z.number().nullable(),
  jmailed: z.number(),
  jstarted: dateTransform,
  jfinished: dateTransform,
  jeta: dateTransform,
  jsubmitted: dateTransform,
  jkey: z.string().nullable(),
  jrate: z.string().nullable(),
  jratenotes: z.string().nullable(),
  jcontact: z.string().nullable(),
  jcontactphone: z.string().nullable(),
  jwoct: z.number(),
  jlotid: z.number().nullable(),
  jqnotes: z.string().nullable(),
  jwarr: z.number().nullable(),
  jwarrid: z.number().nullable(),
  jarchive: z.number().nullable(),
  client: z.object(ClientSchema.shape).nullable().optional()
});

export type Job = z.infer<typeof JobSchema>; 